import { useQuery } from '@tanstack/react-query';
import { Globe } from 'lucide-react';
import { useEffect } from 'react';
import { qk } from '../lib/api/keys';
import { fetchLocales, useLocaleStore } from '../lib/locales';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export function LocaleSwitcher(): JSX.Element {
  const { current, available, setCurrent, hydrate } = useLocaleStore();

  // One-shot hydrate from /locales so we always reflect server-configured roster.
  const { data } = useQuery({
    queryKey: qk.locales(),
    queryFn: fetchLocales,
    staleTime: 5 * 60_000,
  });

  useEffect(() => {
    if (data) hydrate(data);
  }, [data, hydrate]);

  return (
    <Select value={current} onValueChange={setCurrent}>
      <SelectTrigger className="h-9 w-[150px] gap-2">
        <Globe className="h-4 w-4 text-ink-muted" aria-hidden />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {available.map((l) => (
          <SelectItem key={l.code} value={l.code}>
            <span className="mr-1 inline-block w-7 text-xs uppercase tracking-wide text-ink-subtle">
              {l.code}
            </span>
            {l.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
